import React, { useRef, useState } from "react";
import "./index.less";
import { Link } from "react-router-dom";
import logo from '@/assets/footer_logo.png'


const BottomPage = () => {
  const ContacData = {
    list: [
      { title: "邮箱", value: ["xhc@xhc-tech.cn"] },
      // { title: "电话", value: ["014-2515955"] },
      { title: "地址", value: ["广州市黄埔区开创大道 1503号 二栋5楼519-2室"] },
    ],
    content: "AI基础架构产品、方案及服务提供商",
    btnUrl:'/contact'
  };

  const { content = "", btnUrl = "", list = [] } = ContacData;
  return (
    <div className="contact_warp">
      <div className="contact_box">
        <div className="left">
          <div className="logo"><img src={logo} alt="" /></div>
          <div className="content">{content}</div>
        </div>
        <div className="right">
          {list.map((val) => {
            return (
              <div className="contact_item">
                <div className="title">{val.title}</div>
                <div className="content">
                  {val.value.map((data) => {
                    return <div>{data}</div>;
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      
       <div className="back_up">
            <div className="oc">
                <div className="name">版权所有</div>
                <p className='call'>新晧诚科技有限公司. All rights reserved. 
                  <a rel="stylesheet" href='https://beian.miit.gov.cn/#/Integrated/index' target="_blank">粤ICP备2025361602</a></p> 
                  {/* <Link  rel="stylesheet" href='https://beian.miit.gov.cn/#/Integrated/index' target="_blank">粤ICP备2025361602</Link>          */}
            </div>
       </div>
    </div>
  );
};

export default BottomPage;
